import React from 'react';
import Button from '../../../../../utils/components/Button/Button';
import ImageNameDescription from '../../../../../utils/components/ImageNameDescription/ImageNameDescription';
import style from './AdminRoom.module.css'
const AdminReportsRoom = ({ isLoadingListReports, reports, changeReportAdmin = () => { } }) => {
    return (
        <div className={style.content_right_container}>


            {isLoadingListReports ? <div>Cargando...</div> :
                reports && reports.map((report, index) => {


                    let src = null
                    let id = null;
                    let name = null
                    let lastname = null
                        if (report.chatConnectionID.memberType ==="user") {
                           id = report.reportedUserID._id
                           name = report.reportedUserID.name
                           lastname = report.reportedUserID.lastname
                           src = report.reportedUserID.picture && report.reportedUserID.picture.url && report.reportedUserID.picture.url.small
                       } 
                    if (report.chatConnectionID.memberType ==="franchise") {
                        id = report.reportedFranchiseId._id
                        name = report.reportedFranchiseId.socialReason
                        src = report.reportedFranchiseId.picture && report.reportedFranchiseId.picture.url && report.reportedFranchiseId.picture.url.small
                    }
                    if (report.chatConnectionID.memberType ==="representative") {
                        id = report.reportedRepresentativeId._id
                        name = report.reportedRepresentativeId.userID.name
                        lastname = report.reportedRepresentativeId.userID.lastname
                        src = report.reportedRepresentativeId.userID.picture &&
                            report.reportedRepresentativeId.userID.picture.url &&
                            report.reportedRepresentativeId.userID.picture.url.small
                    }
                    if (report.chatConnectionID.memberType ==="warehouse") {
                        id = report.reportedWarehouseId._id
                        name = report.reportedWarehouseId.name
                        src = report.reportedWarehouseId.profileId.picture &&
                        report.reportedWarehouseId.profileId.picture.url &&
                        report.reportedWarehouseId.profileId.picture.url.small
                    } 
                    return (
                        <div key={report._id} className="card-admin">

                            <ImageNameDescription
                                srcImage={src}
                                firstName={name}
                                secondName={lastname}
                            />
                            {report.typeOfReportsIDS.length > 0 &&
                                <div className="text-content-card">{report.typeOfReportsIDS[0].description}</div>}
                            {report.descriptions.length > 0 &&
                                <div className="text-content-card">{report.descriptions[0].message}</div>}
                            {(report.status === 0) && <div className={style.report_btn_container}>


                                <Button
                                    text='Infringe las normas'
                                    onClick={() => { changeReportAdmin({ reportID: report._id, status: 2 }) }}
                                />
                                <Button
                                    text='No infringe las normas'
                                    theme='white'
                                    onClick={() => { changeReportAdmin({ reportID: report._id, status: 1 }) }}
                                />

                            </div>}
                        </div>)
                })
            }



        </div>
    )
};

export default AdminReportsRoom;
